/** Нащадки запису за полем-батьком (UIUX field-types/lookup: «A parent field excludes the record itself and its descendants»). */
import type { IRecord } from '@platform/core/types';

/** Ідентифікатор батька з поля посилання: рядок або об'єкт з id. */
const parentOf = (record: IRecord, key: string): string => {
  const v = record.values[key];
  return typeof v === 'string' ? v : v && typeof v === 'object' && 'id' in v ? String((v as { id: unknown }).id) : '';
};

/** Усі нащадки `selfId` серед `records` за полем `parentKey` (діти, онуки…; цикли не зациклюють). Чиста функція. */
export function descendantsOf(records: readonly IRecord[], selfId: string, parentKey: string): Set<string> {
  const children = new Map<string, string[]>();
  for (const r of records) {
    const p = parentOf(r, parentKey);
    if (p) children.set(p, [...(children.get(p) ?? []), r.id]);
  }
  const found = new Set<string>();
  const queue = [...(children.get(selfId) ?? [])];
  while (queue.length) {
    const id = queue.shift()!;
    if (found.has(id) || id === selfId) continue;
    found.add(id);
    queue.push(...(children.get(id) ?? []));
  }
  return found;
}
